import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BrokerOfficeDetailsParams, BrokerOfficeDetailsResponse } from '@/entity/BrokerOffice';
import { GET_BROKER_OFFICE_DETAILS } from '@/constants';
import { ErrorResponse } from '@/types';

export const useGetBrokerOfficeDetails = (
  params?: BrokerOfficeDetailsParams | null,
  options?: Partial<UseQueryOptions<BrokerOfficeDetailsResponse, AxiosError<ErrorResponse>>>,
) => {
  return useQuery<BrokerOfficeDetailsResponse, AxiosError<ErrorResponse>>({
    queryKey: options?.queryKey ?? ['broker-office-details', params?.officeId],
    queryFn: () =>
      axios
        .get<BrokerOfficeDetailsResponse>(`${GET_BROKER_OFFICE_DETAILS}/${params?.officeId}`)
        .then((res) => res.data),
    staleTime: 0,
    gcTime: 0,
    enabled: Boolean(params?.officeId),
    ...options,
  });
};
